// src/components/etc/VendorRibbon.jsx
import React from "react";
import styles from "./VendorRibbon.module.css";

export default function VendorRibbon({ activeTab, onChange }) {
  const tabs = ["등록", "잔액", "내용", "총괄잔액", "총괄내용"];

  return (
    <div className={styles.ribbon}>
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`${styles.tab} ${activeTab === tab ? styles.active : ""}`}
          onClick={() => onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
